import { Auth } from 'aws-amplify';
import { type LoaderFunctionArgs, matchPath, redirect } from 'react-router-dom';

import {
  AUTH_BYPASS_CHECK_ROUTES,
  ROUTES_PATH,
} from '@/constants/routes.constants';
import { getPathnameFromUrl } from '@/helpers/auth.helper';

export async function loader({ request }: LoaderFunctionArgs) {
  try {
    const pathname = getPathnameFromUrl(request.url);
    const mustBypassAuthCheck = AUTH_BYPASS_CHECK_ROUTES.some(route =>
      matchPath(route, pathname),
    );
    if (mustBypassAuthCheck) return true;
    await Auth.currentSession();
    return redirect(ROUTES_PATH.root);
  } catch {
    return true;
  }
}
